<style lang="scss">
</style>

<template>
<router-view name="SideNav"></router-view>
<router-view class="container" />
</template>

<script>
export default {
    name: 'App',
};
</script>
